
import { store } from "..";
import { donationActions } from "../actions";
import { ACH, APPLE, BANK, CHEQUE, DONATION_IMPACT_TYPES, GOOGLE, HBL, PAYPAL, STRIPE } from "../../constants";
import { handleACHCheckout, handleBankCheckout, handleChequeCheckout, handleGoogleAppleCheckout, handleHBLCheckout, handlePaypalCheckout, handleStripeCheckout } from "../../helpers/PaymentHandlers";

export const handleCheckoutStateChange = (event, state) => {
    const booleanFields = ['contactMeForCorporateMatch', 'doNotContactByPost', 'contactBySms', 'contactByPhone', 'contactByEmail', 'doubleTheImpact', 'coverTheTransactionFee', 'makeGiftAidDonation', 'coverTheTransactionFee', 'donateAnonymously', 'isRecurring', 'leaveAMessageWithDonation'];

    let { id, name, value } = event.target;

    if (name == 'donationAmount') value == 'Others' ? value = "" : value = value.replace(/,/g, '');
    if (name == 'sameBillingForGiftAid') value = Number(value)

    if (booleanFields.includes(name))
        return {
            ...state,
            [name]: event.target.checked
        }

    else if (name == "userContactInfo") {
        if (id == "country" && value) {
            return {
                ...state,
                userContactDetails: {
                    ...state.userContactDetails,
                    country: value.id,
                    countryState: ""
                },
            }
        }
        else if (id == "countryState" && value) {
            return {
                ...state,
                userContactDetails: {
                    ...state.userContactDetails,
                    countryState: value.name
                }
            }
        }
        else {
            return {
                ...state,
                userContactDetails: {
                    ...state.userContactDetails,
                    [id]: value
                }
            }
        }
    }

    else if (name == "giftAidBilling") {
        if (id == "country" && value) {
            return {
                ...state,
                giftAidBilling: {
                    ...state.giftAidBilling,
                    country: value.id,
                    countryState: ""
                }
            }
        }
        else if (id == "countryState" && value) {
            return {
                ...state,
                giftAidBilling: {
                    ...state.giftAidBilling,
                    countryState: value.name
                }
            }
        }
        else {
            return {
                ...state,
                giftAidBilling: {
                    ...state.giftAidBilling,
                    [id]: value
                }
            }
        }
    }

    else return {
        ...state,
        [name]: value
    }
}

export const handleCheckoutCurrencyChange = (currency, state) => {
    if (currency.db_id !== state.selectedCountry.id) {
        return {
            ...state,
            selectedCountry: {
                id: currency.db_id,
                name: currency.name,
                code: currency.code,
                currency: {
                    id: currency.currency_id,
                    code: currency.currency,
                    symbol: currency.symbol
                }
            },
            currencyConversionRate: currency.value,
        }
    }
}

export const handleResetCountryDependentValues = (state) => {

    if (state.isRecurring)
        store.dispatch(donationActions.calculateProductImpact(state.selectedCountry.currency.id, 1, DONATION_IMPACT_TYPES.monthly))

    else
        store.dispatch(donationActions.calculateProductImpact(state.selectedCountry.currency.id, 1, DONATION_IMPACT_TYPES.annual))

    return {
        ...state,
        giftAidBillingAddress:
        {
            country: "",
            city: "",
            address: "",
            zipCode: "",
            countryState: ""
        },
        selectedPaymentMethod: "",
        transactionFeePercentage: 0,
        selectedBank: {
            bank_id: 0,
            bank_details: null
        },
        donationAmount: null,
        selectedPaymentMethod: "",
        doubleTheImpact: false,
        makeGiftAidDonation: false,
        corporateMatchEmployer: "",
        contactMeForCorporateMatch: false,
        makeGiftAidDonation: false,
        sameBillingForGiftAid: 1,
        coverTheTransactionFee: false,
    }

}

export const handlePayment = async (payload) => {
    const method = store.getState().donationCheckout.selectedPaymentMethod;

    switch (method) {
        case BANK:
            await handleBankCheckout(payload)
            break;

        case CHEQUE:
            await handleChequeCheckout(payload)
            break;

        case HBL:
            await handleHBLCheckout(payload);
            break;

        case PAYPAL:
            await handlePaypalCheckout(payload);
            break;

        case ACH:
            await handleACHCheckout(payload);
            break;

        case GOOGLE:
        case APPLE:
            await handleGoogleAppleCheckout(payload);
            break;

        case STRIPE:
            await handleStripeCheckout(payload);
            break;

        default:
            break;
    }
}
